import { environment } from './environments/environment';
import { redirectToNewJourney } from './redirect-to-new-journey';

redirectToNewJourney(`${environment.jornadaNova}/vitrine`, window.location);
